<script setup>
import {onBeforeMount, ref, reactive, nextTick} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue"
import router from "@/router/index.js";
import {editGoodsSalesChannel, itemList, copyMallItem, upOrDownTheShelf} from "@/api/goods/goods.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {categoryListAll} from "@/api/category/category.js";
import {listSaleChannelAll} from "@/api/saleChannel/saleChannel.js";
import {listClub} from "@/api/club/club.js";
import {storeList} from "@/api/post/post.js";
import {onlineStoreList} from "@/api/onlineStore/onlineStore.js";
import YTItemState from "@/components/YTItemState/index.vue";
import {itemListIgnore} from "@/api/goods/ignireTenant.js";

/*初次加载*/
onBeforeMount(async() => {
  await handleGetChannel()
  await handleGetCategory()
  await handleSearch()
})

// 处理获取渠道
const handleGetChannel = async () => {
  try {
    channelEnum.value = await listSaleChannelAll()
  } catch (e) {
    console.log(e)
  }
}
// 渠道枚举
const channelEnum = ref([])
// 商品分类枚举
const categoryEnum = ref([])
// 是否修改渠道
const isChangeChannel = ref(false)
// 缓存的商品信息
const cacheItem = ref(null)
// 选中的渠道
const channelTypeForm = reactive({
  cacheChannelChecked: []
})
// 基本信息表单锚点
const channelTypeRef = ref()
// 渠道校验规则
const checkChannel = (rule, value, callback) => {
  if (channelTypeForm.cacheChannelChecked.length === 0) return callback(new Error('至少选择一个商品的销售渠道'))
  callback()
}
// 基本信息表单校验规则
const channelTypeFormRule = reactive({
  // 因为没有商品删除功能，暂时取消渠道选择的限制条件
  // cacheChannelChecked: [
  //   {validator: checkChannel, trigger: 'blur'}
  // ]
})
// 渠道信息缓存
const cacheSalesChannelList = reactive({
  storeList: [],
  onlineStoreList: [],
  clubList: []
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  salesChannel: null,
  categoryType: null
});
// 获取商品分类
const handleGetCategory = async () => {
  try {
    // 因为分类最多20个所以限制为20
    categoryEnum.value = []
    categoryEnum.value = await categoryListAll()
    console.log(categoryEnum.value)
  } catch (e) {
    console.log(e)
  }
}
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await itemListIgnore(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    // 数据显示处理
    tableData.value.forEach(item => {
      let temp = []
      item.salesChannelCn.map(i => {
        temp.push(i)
      })
      item.salesChannelShow = item.salesChannelCn.length > 0 ? temp.join(" | ") : "-"
      // item.salesChannel.map(item => {
      //   const channel = channelEnum.value.find(i => i.salesChannelType === item)
      //
      // })
    })
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.salesChannel = null
  formData.categoryType = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '商品名称', key: 'goodsName', nowrap: true },
  { title: '所属商家', key: 'tenantName', nowrap: true },
  { title: '商品分类', key: 'innerCategoryName', nowrap: true },
  { title: '销售渠道', key: 'salesChannelShow', nowrap: true },
  { title: '创建时间', key: 'crTime', nowrap: true },
  { title: '商品状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', minWidth: '100px', fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 编辑商品信息
const handleEditItem = (info) => {
  router.push({path: "/addItem", query: {itemId: info.goodsId}})
}
// 修改商品渠道
const changeChannel = (info) => {
  cacheItem.value = info
  cacheSalesChannelList.storeList = info.storeList || []
  cacheSalesChannelList.onlineStoreList = info.onlineStoreList || []
  cacheSalesChannelList.clubList = info.clubList || []
  let temp = []
  info.salesChannel.map(i => {
    const resChannel = channelEnum.value.find(item => item.key === i)
    if (resChannel) temp.push(i)
  })
  channelTypeForm.cacheChannelChecked = temp
  console.log("channelTypeForm", channelTypeForm)
  isChangeChannel.value = true
}
// 取消修改商品渠道信息
const cancelEdit = () => {
  isChangeChannel.value = false
  cacheItem.value = null
  channelTypeForm.cacheChannelChecked = []
  nextTick(async () => {
    await handleSearch()
  })
}
// 保存修改商品渠道信息
const handleEdit = () => {
  channelTypeRef.value.validate(async (valid) => {
    if (valid) {
      const param = {
        goodsId: cacheItem.value.goodsId,
        saleChannelOrganizeSet: []
      }
      // 处理参数格式
      // const storeRes = channelEnum.value.find(item => item.key === "STORE")
      // const onlineStoreRes = channelEnum.value.find(item => item.key === "ONLINE_STORE")
      // const clubRes = channelEnum.value.find(item => item.key === "CLUB")
      // console.log("channelTypeForm.cacheChannelChecked", channelTypeForm.cacheChannelChecked)
      if (channelTypeForm.cacheChannelChecked.includes("CLUB")) {
        let tempParam = {
          salesChannel: "CLUB",
          organizeIdSet: []
        }
        cacheSalesChannelList.clubList.map(i=> {
          tempParam.organizeIdSet.push(i.storeId)
        })
        param.saleChannelOrganizeSet.push(tempParam)
      }
      if (channelTypeForm.cacheChannelChecked.includes("ONLINE_STORE")) {
        let tempParam = {
          salesChannel: "ONLINE_STORE",
          organizeIdSet: []
        }
        cacheSalesChannelList.onlineStoreList.map(i=> {
          tempParam.organizeIdSet.push(i.storeId)
        })
        param.saleChannelOrganizeSet.push(tempParam)
      }
      if (channelTypeForm.cacheChannelChecked.includes("STORE")) {
        let tempParam = {
          salesChannel: "STORE",
          organizeIdSet: []
        }
        cacheSalesChannelList.storeList.map(i=> {
          tempParam.organizeIdSet.push(i.storeId)
        })
        param.saleChannelOrganizeSet.push(tempParam)
      }
      if (channelTypeForm.cacheChannelChecked.includes("COURSE")) {
        let tempParam = {
          salesChannel: "COURSE",
        }
        param.saleChannelOrganizeSet.push(tempParam)
      }
      if (channelTypeForm.cacheChannelChecked.includes("COMPETITION")) {
        let tempParam = {
          salesChannel: "COMPETITION",
        }
        param.saleChannelOrganizeSet.push(tempParam)
      }
      if (channelTypeForm.cacheChannelChecked.includes("POINTS_MALL")) {
        let tempParam = {
          salesChannel: "POINTS_MALL",
        }
        param.saleChannelOrganizeSet.push(tempParam)
      }
      try {
        await editGoodsSalesChannel(param)
        cancelEdit()
        ElMessage.success("修改成功")
      } catch (e) {
        console.log(e)
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
    }
  })
}
// 处理渠道是否可选
// 0驿站/门店 1网店 2俱乐部
// 未分类商品不能选择俱乐部
// 活动、课程只能选择俱乐部
const handleChannelDisabled = (index) => {
//   TODO现在所有商品都为GOODS无法判断是否是未分类、课程、活动。暂时不做处理
  return true
}

// 复制商品
const copyItem = async (info) => {
  console.log("copyItem", info)
  const goodsId = info.goodsId
  try {
    await copyMallItem(goodsId)
    ElMessage.success("复制成功")
    handleSearch()
  } catch (e) {
    console.log("复制失败", e)
  }
}
// 上架/下架
const putOnOrOffTheShelf = async (info) => {
  const param = {
    goodsId: info.goodsId,
    state: info.state === 1 ? 0 : 1
  }
  console.log("putOnOrOffTheShelf", param)
  try {
    await upOrDownTheShelf(param)
    ElMessage.success("上架/下架成功")
    handleSearch()
  } catch (e) {
    console.log("上架/下架失败", e)
  }
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/addItem")
}

/*添加渠道相关弹窗*/
// 渠道弹窗锚点
const YTCheckPanelSalesChannelRef = ref()
// 渠道弹窗翻页锚点
const YTTablePaginationDialogSalesChannelRef = ref()
// 渠道弹窗加载状态
const salesChannelLoading = ref(false)
// 渠道弹窗打开状态
const openSalesChannel = ref(false)
// 渠道弹窗选择销售渠道类型
const openSalesChannelType = ref("ClUB")
// 渠道弹窗的渠道列表
const salesChannelList = ref([])
// 渠道弹窗的渠道列表总条数
const dialogSalesChannelTotal = ref(0)
// 渠道弹窗表单
const dialogForm = reactive({
  salesChannels: [],
  cacheSalesChannel: null,
  cacheSalesChannelList: []
})
// 渠道弹窗表单校验规则
const dialogRules = {

}
// 处理渠道弹窗关闭
const handleSalesChannelClose = () => {
  openSalesChannel.value = false
  salesChannelList.value = []
  dialogSalesChannelTotal.value = 0
  dialogForm.salesChannels = []
  dialogForm.cacheSalesChannel = null
  dialogForm.cacheSalesChannelList = []
}
// 处理选择销售渠道的门店/网店/俱乐部
const handleSalesChannel = (e) => {
  console.log("e", e)
}
// 处理获取销售渠道列表
const handleGetSalesChannel = async (keyword, type) => {
  try {
    if (type === 'search') {
      YTTablePaginationDialogSalesChannelRef.value.resetPage()
    }
    console.log("keyword", keyword)
    let param = {
      page: YTTablePaginationDialogSalesChannelRef.value.getPage(),
      pageSize: YTTablePaginationDialogSalesChannelRef.value.getPageSize()
    }
    let res = null
    if (openSalesChannelType.value === 'CLUB') {
      res = await listClub(param, {name: keyword})
    } else if (openSalesChannelType.value === 'STORE') {
      res = await storeList(param, {name: keyword})
    } else if (openSalesChannelType.value === 'ONLINE_STORE') {
      res = await onlineStoreList(param, {name: keyword});
    }
    salesChannelList.value = []
    salesChannelList.value = res.list
    dialogSalesChannelTotal.value = parseInt(res.total)
  } catch (e) {
    console.log(e)
  }
}
// 处理渠道弹窗的俱乐部/门店/网店展示
const handleSalesChannelShow = (type) => {
  let temp = new Set()
  for (let i = 0;i < channelTypeForm.cacheChannelChecked.length;i++) {
    const res = channelEnum.value.find(item => item.key === type)
    console.log("res", res)
    console.log("channelTypeForm", channelTypeForm)
    console.log("channelTypeForm.cacheChannelChecked[i]", channelTypeForm.cacheChannelChecked[i])
    if (res.key === channelTypeForm.cacheChannelChecked[i]) temp.add(res.key)
  }
  return temp.has(type)
}
// 处理渠道弹窗驿站翻页
const handleChangeDialogSalesChannelPage = () => {
  handleGetSalesChannel()
}
// 渠道弹窗删除渠道tags
const handleCloseDialogStoreTags = (index) => {
  dialogForm.cacheSalesChannelList.splice(index, 1)
}
// 处理删除俱乐部销售渠道tags
const handleCloseSalesChannelClubTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.clubList.splice(index, 1)
}
// 处理删除门店销售渠道tags
const handleCloseSalesChannelStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.storeList.splice(index, 1)
}
// 处理删除网店销售渠道tags
const handleCloseSalesChannelOnlineStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.onlineStoreList.splice(index, 1)
}
// 处理驿站弹窗确认
const handlePanelSalesChannelConfirm = () => {
  let temp = []
  console.log("dialogForm.cacheSalesChannelList", dialogForm.cacheSalesChannelList)
  dialogForm.cacheSalesChannelList.map(i => {
    temp.push({
      storeId: i.storeId,
      storeName: i.name
    })
  })
  if (openSalesChannelType.value === 'CLUB') {
    cacheSalesChannelList.clubList = (temp)
  } else if (openSalesChannelType.value === 'STORE') {
    cacheSalesChannelList.storeList = (temp)
  } else if (openSalesChannelType.value === 'ONLINE_STORE') {
    cacheSalesChannelList.onlineStoreList = (temp)
  }
  handleSalesChannelClose()
}
// 处理渠道添加俱乐部/门店/网店
const handleAddSalesChannel2List = () => {
  const res = salesChannelList.value.find(i => i.storeId === dialogForm.cacheSalesChannel)
  if (dialogForm.cacheSalesChannelList.some(i => i.storeId === res.storeId)) {
    return ElMessage.error("已存在，请勿重复添加")
  }
  dialogForm.cacheSalesChannelList.push(res)
  dialogForm.cacheSalesChannel = null
}
// 处理打开渠道添加俱乐部/门店/网店面板
const handleAddSalesChannel = (type) => {
  openSalesChannel.value = true
  let temp = []
  console.log("type", type)
  openSalesChannelType.value = type
  if (openSalesChannelType.value === 'CLUB') {
    cacheSalesChannelList.clubList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'STORE') {
    cacheSalesChannelList.storeList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'ONLINE_STORE') {
    cacheSalesChannelList.onlineStoreList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  }
  dialogForm.cacheSalesChannelList = temp
  handleGetSalesChannel('', 'search')
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px" v-if="!isChangeChannel">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('any', 'goods:add', 'virtualGoods:add')">增加商品</v-btn>
    </div>
  </div>
  <div class="container_box" v-if="!isChangeChannel">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="start">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.keyword"
                        placeholder="请输入商品名称/编码"
                        label="商品名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.salesChannel"
                        placeholder="选择销售渠道"
                        variant="outlined"
                        label="销售渠道"
                        clearable
                        :items="channelEnum"
                        item-title="description"
                        item-value="key"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.categoryType"
                        placeholder="选择商品分类"
                        variant="outlined"
                        label="商品分类"
                        clearable
                        :items="categoryEnum"
                        item-title="description"
                        item-value="key"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'goods:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'goods:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.salesChannelShow="{ item }">
            {{item.salesChannelShow}}
          </template>

          <template v-slot:item.state="{ item }">
            <YTItemState :state="item.state"></YTItemState>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon class="mg_r_1" icon="mdi-file-edit-outline" color="primary" size="small" @click="handleEditItem(item)" v-show="$handleHasBtnPermission('all', 'goods:edit')"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="渠道"
                  placement="right">
                <v-icon icon="mdi-storefront-outline mg_r_1" color="warning" @click="changeChannel(item)" v-show="$handleHasBtnPermission('all', 'good:edit:channel')"></v-icon>
              </el-tooltip>
              <!-- <el-popconfirm
                class="box-item"
                popper-class="item-popconfirm-white-btn"
                title="确认复制该商品？"
                placement="top"
                confirm-button-text="确认"
                cancel-button-text="取消"
                @confirm="copyItem(item)">
                <template #reference>
                  <div class="cursor-pointer mg_r_1" style="color: #409eff; white-space: nowrap;">复制</div>
                </template>
              </el-popconfirm>
              <el-popconfirm
                class="box-item"
                popper-class="item-popconfirm-white-btn"
                :title="`确认${item.state === 1 ? '下架' : '上架'}该商品？`"
                placement="top"
                confirm-button-text="确认"
                cancel-button-text="取消"
                @confirm="putOnOrOffTheShelf(item)">
                <template #reference>
                  <div class="cursor-pointer mg_r_1" style="color: #409eff; white-space: nowrap;">
                    {{ item.state === 1 ? '下架' : '上架' }}
                  </div>
                </template>
              </el-popconfirm> -->
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <YTCard :title="'通用信息'">
      <template #container>
        <el-form size="large" style="width: 500px;" :model="cacheItem">
          <el-form-item label="商品名称：" prop="goodsName">
            <el-input disabled v-model="cacheItem.goodsName"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </YTCard>
    <YTCard :title="'基本信息'" :sub-title="'至少选择一个商品的销售渠道，选中后可自定义商品在此渠道的销售信息。'" :isShowDivider="false">
      <template #container>
        <el-form
          ref="channelTypeRef"
          :model="channelTypeForm"
          :rules="channelTypeFormRule"
        >
          <el-form-item prop="cacheChannelChecked">
            <el-checkbox-group size="large" v-model="channelTypeForm.cacheChannelChecked">
              <el-checkbox v-for="(item, index) in channelEnum" :key="`changeChannelBox${item.salesChannelName}${index}`" :disabled="!handleChannelDisabled(index)" :label="`${item.description}渠道`" :value="item.key" />
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="俱乐部：" v-if="handleSalesChannelShow('CLUB')">
            <div class="flex_left flex_warp">
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.clubList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelClubTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('CLUB')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="门店：" v-if="handleSalesChannelShow('STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.storeList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('STORE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="网店：" v-if="handleSalesChannelShow('ONLINE_STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.onlineStoreList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelOnlineStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('ONLINE_STORE')"></v-icon>
            </div>
          </el-form-item>
        </el-form>
      </template>
    </YTCard>
    <v-row>
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelEdit">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="handleEdit" :disabled="!$handleHasBtnPermission('all', 'good:edit:channel')">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
  <el-dialog
      v-model="openSalesChannel"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div v-if="openSalesChannelType === 'CLUB'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售俱乐部</div>
      <div v-else-if="openSalesChannelType === 'STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售门店</div>
      <div v-else-if="openSalesChannelType === 'ONLINE_STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售网店</div>
    </template>
    <el-form
        ref="YTCheckPanelSalesChannelRef"
        style="max-width: 100%;"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="salesChannelLoading"
        id="dialogForm"
    >
      <el-form-item label="搜索：">
        <div class="flex">
          <el-select
              style="width: 350px"
              v-model="dialogForm.cacheSalesChannel"
              filterable
              remote
              reserve-keyword
              placeholder="选择"
              remote-show-suffix
              :remote-method="(keyword) => handleGetSalesChannel(keyword, 'search')"
              :loading="salesChannelLoading"
              @change="handleSalesChannel"
              class="mg_r_1"
          >
            <el-option
                v-for="item in salesChannelList"
                :key="item.storeId"
                :label="`${item.name}`"
                :value="item.storeId"
            />
            <template #footer>
              <YTTablePagination ref="YTTablePaginationDialogSalesChannelRef" :totalVisible="5" :pageSize="5" :total="dialogSalesChannelTotal" @page-change="handleChangeDialogSalesChannelPage"></YTTablePagination>
            </template>
          </el-select>
          <v-btn color="success" @click="handleAddSalesChannel2List">添加</v-btn>
        </div>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item label="已选择：">
        <div class="flex_left flex_warp">
          <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in dialogForm.cacheSalesChannelList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseDialogStoreTags(tagIndex)">
            {{ tag.name }}
          </el-tag>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="handleSalesChannelClose">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handlePanelSalesChannelConfirm">确定</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
